import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';

export const getCommonGlobalNavigation = (): {
	menuId: 'FILTERS';
} => ({
	menuId: MenuIdFilters,
});
